import "./App.css";
import { useEffect, useState } from "react";
import {
  createBoard,
  getBoards,
  deleteBoard,
  updateBoard,
  createList,
  updateList,
  deleteList,
  getLists,
  getCards,
  createCard,
  updateCard,
  deleteCard,
  login,
  register
} from "./api";

import API from "./api";

import {
  DragDropContext,
  Droppable,
  Draggable
} from "@hello-pangea/dnd";

function App() {
  // ---------------- AUTH ----------------
  const [user, setUser] = useState(null);

  const [loginForm, setLoginForm] = useState({
    username: "",
    password: ""
  });
  const [loginError, setLoginError] = useState("");

  const [showRegister, setShowRegister] = useState(false);

  const [registerForm, setRegisterForm] = useState({
    username: "",
    email: "",
    password: ""
  });

  // ---------------- ADMIN ----------------
  const [showAdmin, setShowAdmin] = useState(false);
  const [users, setUsers] = useState([]);

  // ---------------- DATA ----------------
  const [boards, setBoards] = useState([]);
  const [selectedBoard, setSelectedBoard] = useState(null);
  const [lists, setLists] = useState([]);
  const [cards, setCards] = useState({});

  const [newBoardName, setNewBoardName] = useState("");
  const [newListName, setNewListName] = useState("");

  // ---------------- MODALS ----------------
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedList, setSelectedList] = useState(null);

  const [showBoardModal, setShowBoardModal] = useState(false);
  const [openBoardMenu, setOpenBoardMenu] = useState(null);
  const [showListModal, setShowListModal] = useState(false);
  const [addCardListId, setAddCardListId] = useState(null);


  const [selectedBoardEdit, setSelectedBoardEdit] = useState(null);
  const [editBoardName, setEditBoardName] = useState("");
  const [newCardForm, setNewCardForm] = useState({
    title: "",
    description: ""
  });

  const [editTitle, setEditTitle] = useState("");
  const [editDescription, setEditDescription] = useState("");
  const [editListTitle, setEditListTitle] = useState("");

  // ---------------- RESTORE SESSION ----------------
  useEffect(() => {
  const token = localStorage.getItem("token");

  if (!token) return;

  API.get("/restoreSession.php")
    .then(res => {
      if (res.data.loggedIn) {
        setUser({
          token,
          username: res.data.username,
          is_admin: Number(res.data.is_admin)
        });
      }
    })
    .catch(err => {
      console.error(err);
      setUser(null);
    });
}, []);

  // ---------------- LOAD BOARDS ----------------
  useEffect(() => {
    if (!user) return;

    getBoards()
      .then((res) => {
        setBoards(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [user]);


  // ---------------- LOAD LISTS + CARDS ---------------- 
  useEffect(() => { 
    if (!selectedBoard) 
      return; 

    setLists([]); 
    setCards({}); 
    
    getLists(selectedBoard.id).then((res) => { 
      setLists(res.data); res.data.forEach((list) => { 
        getCards(list.id).then((cardRes) => { 
          setCards((prev) => ({ 
            ...prev, [list.id]: cardRes.data || [] }
          )); 
        }); 
      }); 
    }); 
  }, [selectedBoard]);

  // ---------------- AUTH ----------------
  const handleRegistration = (e) => {
  e.preventDefault();

  if (
    !registerForm.username.trim() ||
    !registerForm.email.trim() ||
    !registerForm.password.trim()
  ) {
    alert("Please fill out all fields");
    return;
  }

  register({
    username: registerForm.username,
    email: registerForm.email,
    password: registerForm.password
  })
    .then((res) => {
      alert("Account created successfully!");

      // clear form
      setRegisterForm({
        username: "",
        email: "",
        password: ""
      });

      // switch back to login screen
      setShowRegister(false);
    })
    .catch((err) => {
      console.error("Registration error:", err);

      if (err.response?.data?.error) {
        alert(err.response.data.error);
      } else {
        alert("Registration failed");
      }
    });
};
  const handleLogin = (e) => {
  e.preventDefault();

  setLoginError("");

  login(loginForm)
    .then((res) => {
      localStorage.setItem("token", res.data.token);

      setUser({
        token: res.data.token,
        username: res.data.username,
        is_admin: res.data.is_admin
      });
    })
    .catch((err) => {
      if (err.response?.status === 401) {
        setLoginError("Invalid username or password. No account found or credentials are incorrect.");
      } else if (err.response?.status === 400) {
        setLoginError("Please enter both username and password.");
      } else {
        setLoginError("Login failed. Please try again later.");
      }
    });
};

  const handleLogout = () => {
    localStorage.removeItem("token");

    setUser(null);
    setBoards([]);
    setSelectedBoard(null);
  };

  // ---------------- ADMIN ----------------
  const fetchUsers = () => {
    API.get("/getUsers.php")
      .then((res) => {
        setUsers(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleDeleteUser = (id) => {
    API.post("/deleteUser.php", { id })
      .then(() => {
        setUsers((prev) => prev.filter((u) => u.id !== id));
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // ---------------- BOARDS ----------------
  const handleAddBoard = (e) => {
    e.preventDefault();

    if (!newBoardName.trim()) return;

    createBoard({ name: newBoardName })
      .then((res) => {
        setBoards((prev) => [...prev, res.data]);
        setNewBoardName("");
        setShowBoardModal(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleUpdateBoard = (e) => {
  e.preventDefault();

  updateBoard({
    id: selectedBoard.id,
    name: editBoardName
  })
    .then(() => {
      setBoards((prev) =>
        prev.map((b) =>
          b.id === selectedBoard.id
            ? { ...b, name: editBoardName }
            : b
        )
      );

      setSelectedBoardEdit(null);
    })
    .catch((err) => {
      console.error(err);
    });
};

const handleDeleteBoard = (boardId) => {
  if (!window.confirm("Delete this board?")) return;

  deleteBoard(boardId)
    .then(() => {
      setBoards((prev) =>
        prev.filter((b) => b.id !== boardId)
      );

      // If the deleted board is currently open → reset UI
      if (selectedBoard?.id === boardId) {
        setSelectedBoard(null);
        setLists([]);
        setCards({});
      }
    })
    .catch((err) => {
      console.error("Error deleting board:", err);
    });
};

  useEffect(() => {
  console.log("USER:", user);
  console.log("is_admin:", user?.is_admin);
}, [user]);

  // ---------------- LISTS ----------------
  const handleAddList = (e) => {
    e.preventDefault();

    if (!newListName.trim()) return;

    createList({
      board_id: selectedBoard.id,
      title: newListName
    }).then((res) => {
      setLists((prev) => [...prev, res.data]);
      setNewListName("");
      setShowListModal(false);
    });
  };

  const handleUpdateList = () => {
  updateList({
    id: selectedList.id,
    title: editListTitle
  })
    .then(() => {
      setLists((prev) =>
        prev.map((l) =>
          l.id === selectedList.id
            ? { ...l, title: editListTitle }
            : l
        )
      );

      setSelectedList(null);
    })
    .catch((err) => {
      console.error("Error updating list:", err);
    });
};

  const handleDeleteList = (listId) => {
  deleteList(listId)
    .then(() => {
      setLists((prev) => prev.filter((l) => l.id !== listId));
      setSelectedList(null);
    })
    .catch((err) => {
      console.error("Error deleting list:", err);
      alert("Failed to delete list");
    });
};

  // ---------------- CARDS ----------------
  const handleOpenAddCard = (listId) => {
    setAddCardListId(listId);

    setNewCardForm({
      title: "",
      description: ""
    });
  };

  const handleCreateCard = (e) => {
    e.preventDefault();

    if (!newCardForm.title.trim()) return;

    createCard({
      list_id: addCardListId,
      title: newCardForm.title,
      description: newCardForm.description
    }).then((res) => {
      setCards((prev) => ({
        ...prev,
        [addCardListId]: [...(prev[addCardListId] || []), res.data]
      }));

      setAddCardListId(null);
    });
  };

  const handleDeleteCard = (cardId, listId) => {
  deleteCard(cardId).then(() => {
    setCards((prev) => ({
      ...prev,
      [listId]: (prev[listId] || []).filter(
    (c) => String(c.id) !== String(cardId)
  )
}));

    setSelectedCard(null);
  });
};

  const handleUpdateCard = () => {
    updateCard({
      id: selectedCard.id,
      title: editTitle,
      description: editDescription,
      list_id: selectedCard.list_id,
      position: selectedCard.position
    }).then(() => {
      setCards((prev) => {
        const updated = { ...prev };

        Object.keys(updated).forEach((listId) => {
          updated[listId] = updated[listId].map((c) =>
            c.id === selectedCard.id
              ? {
                  ...c,
                  title: editTitle,
                  description: editDescription
                }
              : c
          );
        });

        return updated;
      });

      setSelectedCard(null);
    });
  };

  // ---------------- DRAG & DROP ----------------
  const handleDragEnd = (result) => {
  const { source, destination } = result;

  if (!destination) return;

  const sourceListId = source.droppableId;
  const destListId = destination.droppableId;

  const sourceCards = [...(cards[sourceListId] || [])];
  const destCards =
    sourceListId === destListId
      ? [...sourceCards]
      : [...(cards[destListId] || [])];
  
  const movedCard = { ...sourceCards[source.index] };

  sourceCards.splice(source.index, 1);

  movedCard.list_id = Number(destListId);

  destCards.splice(destination.index, 0, movedCard);

  const updatedSource = sourceCards.map((c, i) => ({
    ...c,
    position: i
  }));

  const updatedDest = destCards.map((c, i) => ({
    ...c,
    position: i
  }));

  setCards((prev) => ({
    ...prev,
    [sourceListId]: updatedSource,
    [destListId]: updatedDest
  }));

  updatedSource.forEach((c, i) => {
    updateCard({
      id: c.id,
      title: c.title,
      description: c.description,
      list_id: Number(sourceListId),
      position: i
    });
  });

  updatedDest.forEach((c, i) => {
    updateCard({
      id: c.id,
      title: c.title,
      description: c.description,
      list_id: Number(destListId),
      position: i
    });
  });
};

  // ---------------- LOGIN UI ----------------
  
  if (!user) {
    return (
      <div className="App">
        <h1>Welcome to the Online Note-Taking System!</h1>
        <h2>{showRegister ? "Register" : "Login"}</h2>

        {!showRegister ? (
          <>
            <form onSubmit={handleLogin}>
              <input
                placeholder="Username"
                value={loginForm.username}
                onChange={(e) =>
                  setLoginForm({
                    ...loginForm,
                    username: e.target.value
                  })
                }
              />

              <input
                type="password"
                placeholder="Password"
                value={loginForm.password}
                onChange={(e) =>
                  setLoginForm({
                    ...loginForm,
                    password: e.target.value
                  })
                }
              />

              <button type="submit">Login</button>
            </form>
            {loginError && (
  <p style={{ color: "red", marginTop: "10px" }}>
    {loginError}
  </p>
)}

            <p style={{ marginTop: "10px", fontSize: "14px" }}>
              Don’t have an account?{" "}
              <button
                type="button"
                onClick={() => setShowRegister(true)}
                  style={{
                  background: "none",
                  border: "none",
                  color: "#4f8cff",
                  cursor: "pointer",
                  textDecoration: "underline",
                  padding: 0,
                  fontSize: "14px"
                }}
              >
                Register
              </button>
            </p>
          </>
        ) : (
          <form onSubmit={handleRegistration}>
            <input
              placeholder="Username"
              value={registerForm.username}
              onChange={(e) =>
                setRegisterForm({
                  ...registerForm,
                  username: e.target.value
                })
              }
            />

            <input
              placeholder="Email"
              value={registerForm.email}
              onChange={(e) =>
                setRegisterForm({
                  ...registerForm,
                  email: e.target.value
                })
              }
            />

            <input
              type="password"
              placeholder="Password"
              value={registerForm.password}
              onChange={(e) =>
                setRegisterForm({
                  ...registerForm,
                  password: e.target.value
                })
              }
            />
            <button type="submit">Create Account</button>
            <p style={{ marginTop: "10px", fontSize: "14px" }}>
              Already have an account?{" "}
              <button
                type="button"
                onClick={() => setShowRegister(false)}
                  style={{
                  background: "none",
                  border: "none",
                  color: "#4f8cff",
                  cursor: "pointer",
                  textDecoration: "underline",
                  padding: 0,
                  fontSize: "14px"
                }}
              >
                Login
              </button>
            </p>
          </form>
        )}
      </div>
    );
  }
  
  // ---------------- MAIN UI ----------------
  return (
    <div className="App">
      <div className="top-bar">
        {user?.is_admin === 1 && (
          <button
            onClick={() => {
              fetchUsers();
              setShowAdmin(true);
            }}
          >
            Users
          </button>
        )}

        <button onClick={handleLogout}>Logout</button>
      </div>

      <h1>
        {Number(user?.is_admin) === 1
          ? `Welcome, Admin`
          : `Welcome, ${user?.username || "User"}!`}
      </h1>

      <h2>
        {Number(user?.is_admin) === 1
        ? `All Boards`
        : `My Boards`}
      </h2>

      <button onClick={() => setShowBoardModal(true)}>
        + Add Board
      </button>

      <div className="boards-container">
  {boards.map((b) => (
    <div
      key={b.id}
      className="board-card"
      onClick={() => setSelectedBoard(b)}
    >
      <div className="board-card-header">
        <span>{b.title || b.name}</span>

        <button
          className="board-menu-button"
          onClick={(e) => {
            e.stopPropagation();
            setSelectedBoard(b);
            setEditBoardName(b.name);

            setOpenBoardMenu(
              openBoardMenu === b.id ? null : b.id
            );
          }}
        >
          ⋮
        </button>
      </div>

      {openBoardMenu === b.id && (
        <div
          className="board-menu"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={() => {
              setSelectedBoardEdit(b);

              setEditBoardName(
                b.title || b.name
              );

              setOpenBoardMenu(null);
            }}
          >
            Update
          </button>

          <button
      onClick={(e) => {
        e.stopPropagation(); // 🚨 prevents opening the board
        handleDeleteBoard(b.id);
      }}
    >
      Delete
    </button>
        </div>
      )}
    </div>
  ))}
</div>

      {selectedBoard && (
        <>
          <button onClick={() => setShowListModal(true)}>
            + Add List
          </button>

          <DragDropContext onDragEnd={handleDragEnd}>
            <div className="lists-container">
              {lists.map((list) => (
                <Droppable
                  key={list.id}
                  droppableId={String(list.id)}
                >
                  {(provided) => (
                    <div
                      className="list-column"
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                    >
                      <h3
                        onClick={() => {
                          setSelectedList(list);
                          setEditListTitle(list.title);
                        }}
                      >
                        {list.title}
                      </h3>

                      <button
                        onClick={() => handleOpenAddCard(list.id)}
                      >
                        + Add Card
                      </button>

                      {(cards[list.id] || []).map((card, index) => (
                        <Draggable
                          key={card.id}
                          draggableId={String(card.id)}
                          index={index}
                        >
                          {(provided) => (
                            <div
                              className="card"
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              onClick={() => {
                                setSelectedCard(card);
                                setEditTitle(card.title);
                                setEditDescription(card.description);
                              }}
                            >
                              <strong>{card.title}</strong>
                              <p>{card.description}</p>
                            </div>
                          )}
                        </Draggable>
                      ))}

                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              ))}
            </div>
          </DragDropContext>
        </>
      )}

      {/* ADD BOARD MODAL */}
      {showBoardModal && (
        <div className="modal">
          <div className="modal-content">
            <h3>Add Board</h3>

            <input
              placeholder="Board name"
              value={newBoardName}
              onChange={(e) => setNewBoardName(e.target.value)}
            />

            <button onClick={handleAddBoard}>Create</button>
            <button onClick={() => setShowBoardModal(false)}>
              Cancel
            </button>
          </div>
        </div>
      )}

      {/*UPDATE BOARD MODAL*/}
      {selectedBoardEdit && (
        <div className="modal">
          <div className="modal-content">
            <h3>Edit Board</h3>

            <input
              value={editBoardName}
              onChange={(e) =>
                setEditBoardName(e.target.value)
              }
            />

            <button 
              onClick={handleUpdateBoard}>
              Save
            </button>

            <button
              onClick={() => setSelectedBoardEdit(null)}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* ADD LIST MODAL */}
      {showListModal && (
        <div className="modal">
          <div className="modal-content">
            <h3>Add List</h3>

            <input
              placeholder="List name"
              value={newListName}
              onChange={(e) => setNewListName(e.target.value)}
            />

            <button onClick={handleAddList}>Create</button>
            <button onClick={() => setShowListModal(false)}>
              Cancel
            </button>
          </div>
        </div>
      )}

      {/*UPDATE LIST MODAL */}
      {selectedList && (
        <div className="modal">
          <div className="modal-content">
            <h3>Edit List</h3>

            <input
              value={editListTitle}
              onChange={(e) => setEditListTitle(e.target.value)}
            />

            <button
              onClick={() => {
                handleUpdateList(selectedList.id);
              }}
            >
              Save
            </button>

            <button
              onClick={() => handleDeleteList(selectedList.id)}
            >
              Delete
            </button>

            <button onClick={() => setSelectedList(null)}>
              Close
            </button>
          </div>
        </div>
      )}

      {/* ADD CARD MODAL */}
      {addCardListId && (
        <div className="modal">
          <div className="modal-content">
            <h3>Add Card</h3>

            <input
              placeholder="Title"
              value={newCardForm.title}
              onChange={(e) =>
                setNewCardForm((p) => ({
                  ...p,
                  title: e.target.value
                }))
              }
            />

            <textarea
              placeholder="Description"
              value={newCardForm.description}
              onChange={(e) =>
                setNewCardForm((p) => ({
                  ...p,
                  description: e.target.value
                }))
              }
            />

            <button onClick={handleCreateCard}>Create</button>
            <button onClick={() => setAddCardListId(null)}>
              Cancel
            </button>
          </div>
        </div>
      )}

      {/*UPDATE CARD MODAL */}
      {selectedCard && (
        <div className="modal">
          <div className="modal-content">
            <h3>Edit Card</h3>

            <input
              value={editTitle}
              onChange={(e) => setEditTitle(e.target.value)}
            />

            <input
              value={editDescription}
              onChange={(e) => setEditDescription(e.target.value)}
            />

            <button
              onClick={() => {
                handleUpdateCard(selectedCard.id);
              }}
            >
              Save
            </button>

            <button
              onClick={() => handleDeleteCard(selectedCard.id)}
            >
              Delete
            </button>

            <button onClick={() => setSelectedCard(null)}>
              Close
            </button>
          </div>
        </div>
      )}

      {/* ADMIN MODAL */}
      {showAdmin && (
        <div className="modal">
          <div className="modal-content">
            <h2>Admin Dashboard</h2>

            {users.map((u) => (
              <div key={u.id}>
                <strong>{u.username}</strong>

                <button
                  onClick={() => handleDeleteUser(u.id)}
                >
                  Delete
                </button>
              </div>
            ))}

            <button onClick={() => setShowAdmin(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;